export default __webpack_public_path__ + "static/meaningImg-54c25f2acd4dfed629d2527294ab23f6.png";